<template>
  <div class="bbp-input-textarea">
    <textarea
      :class="[
        'bbp-input',
        'bbp-input_textarea',
        error && 'bbp-input_error'
      ]"
      @keydown.enter.stop
      v-model="value"
      :disabled="input.disabled"
      v-autofocus="!!input.autofocus"
      :style="{height: input.height}"
      :placeholder="input.placeholder"
    />
    <transition name="fade">
      <span class="bbp-input-textarea__error bbp-error-text" v-if="error">{{error}}</span>
    </transition>
  </div>
</template>

<script>
import {get} from 'lodash'

export default {
  name: 'BBPTextarea',
  props: ['input', 'model', 'errorText'],
  data () {
    return {
      value: '',
      error: ''
    }
  },
  methods: {
    setDefaultVal () {
      const value = get(this.model, this.input.model, '')
      if (value) this.value = value
    }
  },
  watch: {
    value () {
      this.error = false
      this.$emit('error', false)
      this.$emit('input', this.value)
    },
    errorText () {
      this.error = this.errorText
    }
  },
  beforeMount () {
    this.setDefaultVal()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-input-textarea {
    position: relative;

    &__error {
      position: absolute;
      bottom: 10px;
      right: 12px;
      font-size: 13px;
      line-height: 16px;
      font-weight: 400;
      color: $color-pomegranate;
      pointer-events: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPForm/BBPTextarea/BBPTextarea.vue